import { Property } from '@bbraun/bav-reporting/ui-report-editor';
import { IS_GREATER_OR_EQUAL_NUMBER_ID } from '../../../../validation/factories/is-greater-or-equal-number-validator-factory';
import { IS_NUMBER_ID } from '../../../../validation/factories/is-number-validator-factory';

export function createPhosphateMgPerDlMeanProperty(): Property {
  return {
    title: 'Phosphate - Mean',
    technicalName: 'phosphateMgPerDlMean',
    dataType: 'number',
    unit: 'mg/dl',
    highlighted: false,
    subName: null,
    formula: null,
    validation: [
      { validator: IS_NUMBER_ID },
      {
        validator: IS_GREATER_OR_EQUAL_NUMBER_ID,
        options: {
          config: {
            minimum: 0,
          },
        },
      },
    ],
  };
}
